import { InfoCircleFilled } from '@ant-design/icons';
import { Card, theme } from 'antd';
import { useTranslation } from 'react-i18next';

export const EndDateExpiry = () => {
	const { t } = useTranslation();
	const {
		token: { red5 },
	} = theme.useToken();

	return (
		<Card>
			<div className="flex items-center justify-center py-4 text-xl">
				<InfoCircleFilled style={{ fontSize: '16px', color: red5 }} />
				<h4 className="ml-2">{t('interviewTimelineCompleted')}</h4>
			</div>
		</Card>
	);
};
